import { render, staticRenderFns } from "./Activity_Details.vue?vue&type=template&id=3874fa98&style=height%3A%20100%25%3B"
import script from "./Activity_Details.vue?vue&type=script&lang=js"
export * from "./Activity_Details.vue?vue&type=script&lang=js"
import style0 from "./Activity_Details.vue?vue&type=style&index=0&id=3874fa98&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports